export enum ExternalVariable {
  DRY_BULB = "Dry Bulb",
  WET_BULB = "Wet Bulb",
  HUMIDITY = "Relative Humidity",
  RATIO = "Humidity Ratio"
}